import { configureStore, isRejectedWithValue } from "@reduxjs/toolkit";
import { apiSlice } from "../services/apiSlice";
import tokenRefresher from "../middleware/tokenRefresher";
import authReducer from "../features/auth/authSlice";
import queryScopeReducer from "../features/searchQuery/QuerySlice";
let lastErrorTime = 0;
const THROTTLE_TIME = 3000;



const rtkQueryErrorLogger = () => (next: any) => (action: any) => {

  const now = Date.now();
  if (
    action?.payload?.status === 401 &&
    !(action?.payload?.data?.message === "Incorrect username or password.")
  ) {
    //  showToast(
    //   "Fetch Failed",
    //   action?.payload?.data?.error,
    //   "error"
    // );
    window.location.href = "/";

    return;
  } else if (action?.payload?.status === 401) {
    window.location.href = "/";
    return;
  }

  if (action?.payload?.status === 404) {
    // showToastOutsideReact(
    //   "Invalid credentials",
    //   "invalid credentials - no user found",
    //   "error"
    // );

    return;
  }

  if (
    action?.payload?.status === 504 ||
    action?.payload?.status === "FETCH_ERROR"
  ) {
    const user = localStorage.getItem("authData");
    if (user && now - lastErrorTime > THROTTLE_TIME) {
      //   showToastOutsideReact(
      //     "Failed to process your request.",
      //     "504: Please contact IT Support.",
      //     "error"
      //   );
      lastErrorTime = now;
    }
    return;
  }

  if (isRejectedWithValue(action)) {
    console.warn("We got a rejected action!");
    // action?.payload?.data?.error !== "Please activate your account first" &&
    //   !Array?.isArray(action?.payload?.data?.error) &&
    //   showToastOutsideReact(
    //     action?.payload?.data?.error ||
    //       action?.payload?.data?.message ||
    //       "Something went wrong!",
    //     "Something went wrong!",
    //     "error"
    //   );
    lastErrorTime = now;
  }
  return next(action);
};


export const store = configureStore({
  reducer: {
    [apiSlice.reducerPath]: apiSlice.reducer,
      auth: authReducer,
      queryScope:queryScopeReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    })
      //   .concat(tokenRefresher) // <- should come BEFORE apiSlice.middleware
      .concat(apiSlice.middleware)
      .concat(rtkQueryErrorLogger),
  devTools: process.env.NODE_ENV !== "production",
});


export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
